import { render, staticRenderFns } from "./FieldDataTableWindow.vue?vue&type=template&id=5000c3cc&scoped=true&"
import script from "./FieldDataTableWindow.vue?vue&type=script&lang=js&"
export * from "./FieldDataTableWindow.vue?vue&type=script&lang=js&"
import style0 from "./FieldDataTableWindow.vue?vue&type=style&index=0&id=5000c3cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5000c3cc",
  null
  
)

export default component.exports